'use client';

import { useEffect, useState, type ReactNode } from 'react';
import {
  bindBurialPointToWindow,
  bindGlobalClickBurial,
  burialPoint,
  getPageViewBurialPayload,
} from '../lib/burial-point';

function readLocationKey() {
  if (typeof window === 'undefined') return '';
  return `${window.location.pathname}${window.location.search}`;
}

/**
 * 全局埋点：挂 window.burialPoint，全局 click，URL 变化上报 user_page_view。
 */
export default function BurialPointProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [locationKey, setLocationKey] = useState(readLocationKey);

  useEffect(() => {
    bindBurialPointToWindow();
    const unbindClick = bindGlobalClickBurial();

    const sync = () => setLocationKey(readLocationKey());
    window.addEventListener('popstate', sync);

    const { pushState, replaceState } = window.history;
    window.history.pushState = function (...args) {
      const result = pushState.apply(this, args as Parameters<typeof pushState>);
      sync();
      return result;
    };
    window.history.replaceState = function (...args) {
      const result = replaceState.apply(
        this,
        args as Parameters<typeof replaceState>,
      );
      sync();
      return result;
    };

    sync();

    return () => {
      unbindClick();
      window.removeEventListener('popstate', sync);
      window.history.pushState = pushState;
      window.history.replaceState = replaceState;
    };
  }, []);

  useEffect(() => {
    if (!locationKey) return;
    const timer = window.setTimeout(() => {
      burialPoint('user_page_view', getPageViewBurialPayload());
    }, 1000);
    return () => window.clearTimeout(timer);
  }, [locationKey]);

  return children;
}
